import axios from "~/plugins/axios";

const baseEndpoint = "/web_api/v1/group_action";

export default {
  getAvailableGroupActions(searchId) {
    return axios.get(`${baseEndpoint}/search/${searchId}`)
      .then((response) => response.data);
  },
  startGroupAction(searchId, action, settings = null) {
    return axios.post(`${baseEndpoint}/search/${searchId}`, {
      action,
      settings,
    })
      .then((response) => response.data);
  },
  startGroupActionByModel(model, action, settings = null) {
    return axios.post(`${baseEndpoint}/action/${model}`, {
      action,
      settings,
    })
      .then((response) => response.data);
  },
  getGroupActionTrackers(searchId) {
    return axios.get(`${baseEndpoint}/search/${searchId}/trackers`)
      .then((response) => response.data);
  },
  getCompareGroupTrackers(searchId) {
    return axios.get(`${baseEndpoint}/search/${searchId}/trackers`)
      .then((response) => response.data);
  },
  getGroupActionByActionTag(actionTag) {
    return axios.get(`${baseEndpoint}/action/${actionTag}`)
      .then((response) => response.data);
  },
  getGroupActionByAutomationActionId(automationActionId) {
    return axios.get(`${baseEndpoint}/action/by_automation_action/${automationActionId}`)
      .then((response) => response.data);
  },
  getTracker(trackerId) {
    return axios.get(`${baseEndpoint}/trackers/${trackerId}`)
      .then((response) => response.data);
  },
};
